import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  CalendarDaysIcon,
  ClockIcon,
  ArrowRightOnRectangleIcon,
  Bars3Icon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

const Header = ({ onMenuClick }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Déconnexion réussie');
    } catch (error) {
      toast.error('Erreur lors de la déconnexion');
    }
  };

  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case '/':
      case '/dashboard':
        return 'Tableau de bord';
      case '/bookings':
        return 'Réservations';
      case '/clients':
        return 'Clients';
      case '/coaches':
        return 'Coachs';
      case '/services':
        return 'Services';
      case '/schedule':
        return 'Planning';
      case '/analytics':
        return 'Analyses';
      case '/settings':
        return 'Paramètres';
      default:
        return 'Nazaï Studio Admin';
    }
  };

  const getCurrentDate = () => {
    return new Date().toLocaleDateString('fr-FR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getCurrentTime = () => {
    return new Date().toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 mr-5 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
        >
          <span className="sr-only">Ouvrir le menu</span>
          <Bars3Icon className="h-6 w-6" />
        </button>

        {/* Left Section */}
        <div className="flex-1 lg:flex-none">
          <h1 className="text-2xl font-bold text-gray-900">{getPageTitle()}</h1>
          <div className="flex items-center mt-1 space-x-4 text-sm text-gray-500">
            <div className="flex items-center">
              <CalendarDaysIcon className="h-4 w-4 mr-1" />
              <span>{getCurrentDate()}</span>
            </div>
            <div className="flex items-center">
              <ClockIcon className="h-4 w-4 mr-1" />
              <span>{getCurrentTime()}</span>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-4">

          {/* User Profile & Logout */}
          <div className="flex items-center space-x-2 sm:space-x-4 pl-3 sm:pl-6 border-l border-gray-200">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-medium text-gray-900">{user?.full_name}</p>
              <p className="text-xs text-gray-500">{user?.role === 'super_admin' ? 'Super Admin' : 'Admin'}</p>
            </div>
            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-sm">{user?.full_name?.charAt(0) || 'A'}</span>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
              title="Se déconnecter"
            >
              <ArrowRightOnRectangleIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
